import React from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import { InstitucionesActivasAPI } from "../../services/api/instituciones-activas";
import { CancelRequestController } from "../../util/cancel-request-controller";
import { store } from "../Store";


const staticOptions = {
    title: {
        id: 'title',
        name: {
            en:'Find your institution',
            es:'Busca tu institución'
        }
    },
    institucionNoEncontrada: {
        id: 'no-encontrado',
        name: {
            en:'My institution does not appear in the list',
            es:'Mi institución no aparece en la lista'
        }
    }
}

/**
 * Componente para seleccionar instituciones.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {function} props.onChange - Función de retorno de llamada que se ejecuta cuando se selecciona una institución.
 * @returns {JSX.Element} Elemento JSX que representa el componente.
 */
export const InstitutosSelect = ({ onChange }) => {

    const [instituciones, setInstituciones] = useState([
        staticOptions.title,
        staticOptions.institucionNoEncontrada
    ]);

    const [defaultSelectedId, setDefaultSelectedId] = useState(staticOptions.title.id);
    const {state} = useContext(store);


    const onChangeHandler = (value)=>{
        setDefaultSelectedId(value);
        onChange&&onChange(value);
    }

    useEffect(() => {
        const abortController = new CancelRequestController();

        const updateInstituciones = async () => {
            await InstitucionesActivasAPI
                .obtenerDatos({ abortSignal: abortController?.signal })
                .then(insti => {
                    insti = insti.map(v => {
                        return {
                            id: v,
                            name: {
                                en:v,
                                es:v
                            }
                        }
                    })
                    setInstituciones([
                        staticOptions.title,
                        ...insti,
                        staticOptions.institucionNoEncontrada
                    ])
                })
                .catch(error => console.error(error))
        }

        updateInstituciones();

        return () => {
            abortController.abort();
        }

    }, [])



    return (
        <>
            <select
                className="w-100 background--bg onbackground-primary--color secondary-inverse--bordered"
                name="Selecciona una institución"
                onChange={(e) => onChangeHandler(e.target.value)}
                value={defaultSelectedId}
            >
                {instituciones.map(institucion => {
                    return (
                        <option
                            key={institucion?.id}
                            value={institucion?.id}
                            disabled={institucion?.id === 'title'}>
                            {institucion?.name[state?.idioma] || institucion?.name?.es}
                        </option>
                    )
                })}
            </select>
        </>
    )

}